<template>
  <div>
    <slot name="activator" v-bind="activator"/>
    <div class="report-dialog" v-if="showDialog">
      <div class="card report-card">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      value: Boolean
    },
    data() {
      return {
        showDialog: this.value,
        activator: {
          open: () => {
            this.showDialog = !this.showDialog;
          }
        },
      }
    },
    watch: {
      value(v) {
        this.showDialog = v;
      },
      // Esto está aquí para facilitar los tests de este componente
      showDialog(v) {
        this.$emit('input', v);
      }
    }
  }
</script>